import { RichText } from "components/RichTextWidget";
import { Container, Heading4 } from "shared/components";

import styles from "./Content068.module.scss";

export const Content068 = ({ payload }) => {
  const title = payload?.headline ?? "";
  const content = payload?.content ?? "";

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.inner}>
          {title && (
            <Heading4 className={styles.title} color="dark">
              {title}
            </Heading4>
          )}
          <RichText value={content} className={styles.content} />
        </div>
      </Container>
    </div>
  );
};

export default Content068;
